const columns = [
  {
    field: 'Name',
    headerName: 'BOM名称',
    cellClass: 'cell-aContainer',
    cellRenderer(params) {
      return `<a
      href="${params.data.FilePath}"
      download="${params.data.Name}">
      ${params.data.Name}
      </a>`;
    }
  },
  {
    field: 'UploadDateTime',
    headerName: '上传时间',
    valueFormatter(params) {
      return params.value;
    }
  },
  {
    field: 'PartNoNum',
    headerName: '元器件数'
  },
  // {
  //   field: 'CompletelyNum',
  //   headerName: '已匹配',
  //   valueFormatter(params) {
  //     return params.value + params.data.PartCompletelyNum;
  //   }
  // },
  // {
  //   field: 'OtherNum',
  //   headerName: '无法匹配'
  // },
  {
    field: 'MatchingRate',
    headerName: '匹配度',
    valueFormatter(params) {
      const data = params.data;
      return `${Math.round(
        ((data.CompletelyNum + data.PartCompletelyNum) / data.PartNoNum) * 100
      )}%`;
    }
  },
  {
    field: 'BomNum',
    headerName: '采购套数'
  },
  {
    field: 'OrderAmount',
    headerName: '销售总额',
    valueFormatter(params) {
      return params.value ? `¥${params.value}` : '--';
    }
  },
  {
    field: 'PurchaseAmount',
    headerName: '采购总额',
    valueFormatter(params) {
      return params.value ? `¥${params.value}` : '--';
    }
  },
  {
    field: 'GrossRateString',
    headerName: '利润率'
  },
  {
    field: 'Profit',
    headerName: '利润',
    valueFormatter(params) {
      return params.value ? `¥${params.value}` : '--';
    }
  },

  {
    field: 'FromCompanyName',
    headerName: '公司名称',
    hide: true
  },
  {
    field: 'Status',
    headerName: '状态',
    valueFormatter(params) {
      let StatusStr = '';
      switch (params.value) {
        case 0:
          // StatusStr = '正在匹配';
          StatusStr = '未发送';
          break;
        case 1:
          // StatusStr = '等待审核';
          StatusStr = '未发送';
          break;
        case 2:
          StatusStr = '配单成功';
          break;
        case 3:
          StatusStr = '已取消';
          break;

        default:
          StatusStr = '';
          break;
      }
      return StatusStr;
    },
    hide: true,
    cellStyle(params) {
      if ([0, 1].includes(params.value)) {
        return {
          color: 'red'
        };
      } else {
        return { color: '#333' };
      }
    }
  },

  {
    field: 'Operation',
    headerName: '操作'
  }
];

export { columns };
